import { ResponsivePie } from "@nivo/pie";
import React from "react";
import Text from "../../Tags/Text";
import { Numeral } from "react-numeral";

export default function CreditPieGraph({ data, heading = "", colorA = "#535862", colorB = "#E9EAEB" }) {
  const returnRemaningText = (value) => {
    if (value === "unlimited") {
      return "∞";
    } else if (value > 0) {
      return value;
    } else {
      return "-";
    }
  };
  return (
    <div className="flex space-x-6 items-center">
      <div className="w-[160px] h-[160px] flex items-center justify-center">
        {data?.total_allocated !== "unlimited" &&
        data?.total_allocated > 0 &&
        (data.used || data.remaining) ? (
          <ResponsivePie
            data={[
              {
                id: "used",
                value: data?.used || 0,
                color: colorA,
              },
              {
                id: "remaining",
                value: data?.remaining || 0,
                color: colorB,
              },
            ]}
            margin={{ top: 10, right: 0, bottom: 10, left: 0 }}
            innerRadius={0.7}
            padAngle={0}
            cornerRadius={0}
            colors={{ datum: "data.color" }}
            activeOuterRadiusOffset={8}
            borderWidth={0}
            borderColor={{
              from: "color",
              modifiers: [["darker", 0.2]],
            }}
            arcLinkLabelsSkipAngle={360} // Setting a high skip angle effectively hides all link labels
            arcLinkLabelsTextColor="#333333"
            arcLinkLabelsThickness={0} // Set thickness to 0 to hide the lines
            arcLinkLabelsColor={{ from: "color" }}
            arcLabelsSkipAngle={360}
            arcLabelsTextColor={{
              from: "color",
              modifiers: [["darker", 2]],
            }}
            enableArcLabels={false}
            tooltip={({ datum }) => (
              <div
                style={{
                  padding: "6px 10px",
                  background: "white",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  color: "#111827",
                  fontSize: "13px",
                }}
              >
                <strong>Credit {datum.id}</strong>: {datum.value}
              </div>
            )}
            legends={[
              {
                anchor: "right",
                direction: "column",
                justify: false,
                translateX: 130,
                translateY: 0,
                itemsSpacing: 10,
                itemWidth: 100,
                itemHeight: 10,
                itemTextColor: "#999",
                itemDirection: "left-to-right",
                itemOpacity: 1,
                symbolSize: 10,
                symbolShape: "circle",
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemTextColor: "#000",
                    },
                  },
                ],
              },
            ]}
          />
        ) : data?.total_allocated === "unlimited" ? (
          <div className="bg-transparent w-[140px] h-[140px] rounded-full border-[20px] border-[#717680] inline-flex justify-center items-center text-3xl">
            ∞
          </div>
        ) : (
          <div className="bg-transparent w-[140px] h-[140px] rounded-full border-[20px] border-[#E9EAEB]"></div>
        )}
      </div>
      <div>
        {heading && heading}
        <div className="flex space-x-12 mt-6">
          <div>
            <Text>Current balance</Text>
            <Text size="h5" className="mt-2">
              {returnRemaningText(data?.remaining)}
            </Text>
          </div>
          <div>
            <Text>Credits used</Text>
            <Text size="h5" className="mt-2">
              {data?.used || "-"}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
